import React from 'react'
import { X } from 'lucide-react'
import type { useTurbineDetailViewModel } from '../useTurbineDetailViewModel'

type VM = ReturnType<typeof useTurbineDetailViewModel>

interface VideoPlayerModalProps {
  existingVideos: VM['existingVideos']
  playingVideoId: VM['playingVideoId']
  setPlayingVideoId: VM['setPlayingVideoId']
}

/**
 * Video oynatici lightbox'i.
 *
 * ORTAK `Modal` TABANINA TASINMADI (bilerek): %90 opak siyah zemin uzerinde tam
 * genislikte bir <video> gosterir; `Modal`'in beyaz panel + p-8 + baslik duzeni
 * oynaticiyi kucultur ve kontrolleri sikistirirdi. Ayrica bu bilesende
 * gosterilecek bir hata durumu yok -- video silme/yukleme hatalari
 * `VideoSection` icindeki bant ve toast ile veriliyor.
 */
const VideoPlayerModal: React.FC<VideoPlayerModalProps> = ({
  existingVideos,
  playingVideoId,
  setPlayingVideoId,
}) => {
  return (
    <>
      {/* Video Player Modal */}
      {playingVideoId && (
        <div
          className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
          onClick={() => setPlayingVideoId(null)}
        >
          <div
            className="relative w-full max-w-6xl"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={() => setPlayingVideoId(null)}
              className="absolute -top-12 right-0 text-white hover:text-gray-300 transition-colors"
            >
              <X className="w-8 h-8" />
            </button>

            {/* Video Player */}
            <div className="bg-black rounded-lg overflow-hidden">
              <video
                className="w-full max-h-[80vh]"
                controls
                autoPlay
                src={existingVideos.find(v => v.id === playingVideoId)?.video_url}
                onEnded={() => setPlayingVideoId(null)}
              >
                Tarayıcınız video oynatmayı desteklemiyor.
              </video>
            </div>

            {/* Video Info */}
            {existingVideos.find(v => v.id === playingVideoId) && (
              <div className="mt-4 text-white">
                <h3 className="text-lg font-semibold">
                  {existingVideos.find(v => v.id === playingVideoId)?.original_filename}
                </h3>
                <div className="flex items-center gap-3 mt-2 text-sm text-gray-300">
                  <span>
                    {((existingVideos.find(v => v.id === playingVideoId)?.file_size_bytes || 0) / 1024 / 1024).toFixed(1)} MB
                  </span>
                  <span>•</span>
                  <span>
                    {new Date(existingVideos.find(v => v.id === playingVideoId)?.uploaded_at || '').toLocaleDateString('tr-TR')}
                  </span>
                  {existingVideos.find(v => v.id === playingVideoId)?.first_name && (
                    <>
                      <span>•</span>
                      <span>
                        {existingVideos.find(v => v.id === playingVideoId)?.first_name}{' '}
                        {existingVideos.find(v => v.id === playingVideoId)?.last_name}
                      </span>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  )
}

export default VideoPlayerModal
